import { render } from "./Identification.vue?vue&type=template&id=44cfc2e0"
import script from "./Identification.vue?vue&type=script&lang=js"
export * from "./Identification.vue?vue&type=script&lang=js"
script.render = render
/* hot reload */
if (module.hot) {
  script.__hmrId = "44cfc2e0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('44cfc2e0', script)) {
    api.reload('44cfc2e0', script)
  }
  
  module.hot.accept("./Identification.vue?vue&type=template&id=44cfc2e0", () => {
    api.rerender('44cfc2e0', render)
  })

}

script.__file = "src/icons/components/filled/Identification.vue"

export default script